import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Icon } from '@iconify/react';
import { Stack, useTheme, Typography, CardActionArea } from '@mui/material';

import { Strings } from '@app/constants';
import { GoBackButton, SideDrawer } from '@app/components';
import { SvgColor } from '@app/components/svg-color';
import { logout, selectLoginState } from '@app/modules/auth';
import { Preferences } from './preferences';
import { MyProfile } from './my-profile';

interface Props {
  openNav: any;
  onCloseNav: VoidFunction;
}
const ProfileSettings = ({ openNav, onCloseNav }: Props) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { data } = useSelector(selectLoginState);

  const [tab, setTab] = useState<any>(false);

  const profilePages = [
    {
      pageName: Strings.pageTitle.myProfile,
      icon: `/assets/icons/ic_user.svg`,
      goTo: <MyProfile />,
    },
    {
      pageName: Strings.pageTitle.preferences,
      icon: `/assets/icons/ic_preferences.svg`,
      goTo: <Preferences />,
    },
    // {
    //   pageName: Strings.pageTitle.notificationSettings,
    //   icon: `/assets/icons/ic_settings.svg`,
    //   goTo: <MyProfile />,
    // },
  ];

  return (
    <SideDrawer openNav={openNav} onCloseNav={onCloseNav}>
      <GoBackButton onClick={onCloseNav} sx={{ width: 40, position: 'absolute' }} />

      <Stack sx={{ alignItems: 'center', p: 4 }}>
        <Stack sx={[styles.imageContainer, { bgcolor: theme.palette.secondary.light }]}>
          <Icon
            icon={'solar:user-bold'}
            color={theme.palette.primary.main}
            height={70}
            width={70}
          />
        </Stack>
        <Typography variant="h4" mb={4}>
          {data?.name}
        </Typography>
        {profilePages.map((page, index) => {
          return (
            <CardActionArea
              key={index}
              sx={{
                borderBottom: '1px solid lightGrey',
                height: '60px',
              }}
              onClick={() => setTab(page?.goTo)}
            >
              <Stack sx={styles.listContainer}>
                <Stack sx={{ flexDirection: 'row', alignItems: 'center' }}>
                  <SvgColor src={page.icon} mr={2} color={theme.palette.primary.main} />
                  <Typography> {page.pageName}</Typography>
                </Stack>
                <Icon icon={'uiw:right'} />
              </Stack>
            </CardActionArea>
          );
        })}
        <SideDrawer openNav={tab} onCloseNav={() => setTab(false)} hideBackdrop>
          <Stack>
            <GoBackButton onClick={() => setTab(false)} sx={{ width: 40, position: 'absolute' }} />
            {tab}
          </Stack>
        </SideDrawer>

        {/* ------------------------------------------------ */}
        <CardActionArea onClick={() => dispatch(logout())} sx={styles.logoutButton}>
          <Stack
            sx={{
              flexDirection: 'row',
              alignItems: 'center',
              color: theme.palette.primary.main,
              justifyContent: 'space-between',
            }}
          >
            <Icon icon={'material-symbols:logout-sharp'} height={30} />
            <Typography>{Strings.button.logout}</Typography>
          </Stack>
        </CardActionArea>
      </Stack>
    </SideDrawer>
  );
};

const styles = {
  imageContainer: {
    height: '120px',
    width: '120px',
    p: -1,
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    borderRadius: 50,
    boxShadow: '0px 2px 5px rgba(73, 67, 67, 0.2)',
    mb: 2,
  },
  listContainer: {
    width: '100%',
    my: 2,
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    textAlign: 'center',
  },
  logoutButton: { position: 'absolute', bottom: 20, width: 80 },
};

export { ProfileSettings };
